import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@mui/lab/Autocomplete";
import "./CallDashboard.css";
import HeaderNavigation from "../../../../Componants/Common/header Navigation/HeaderNavigation";
import CommonButton from "../../../../Componants/Common/Button";
import {
  Box,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import JobsheetView from "./JobsheetView";
import CloseIcon from "@mui/icons-material/Close";
import RepairUpdate from "./RepairUpdate";
import {
  assignEngineer,
  fetchBrandDropdownList,
  fetchEngineerList,
  fetchJobList,
  fetchJobNumber,
  fetchJobStatus,
  fetchServieCenterList,
} from "../../../../API Service/apiService";
import Loader from "../../../../Componants/Common/Loader";
import { Button, Tooltip, Typography } from "@material-ui/core";
import toast, { Toaster } from "react-hot-toast";
import Paginate from "../../../../Componants/Common/Paginate";
import DynamicTabs from "../../../../components/DynamicTabs";
import { formatDate, formatDateDynamic } from "../../../../utils/dateFormatter";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxHeight: "90vh", // Limit the height to 90% of the viewport height
  overflowY: "auto", // Enable vertical scrolling when content overflows
  bgcolor: "#EFF3FE",
  border: "2px solid #000",
  boxShadow: 24,
  border: "none !important",
  borderRadius: "10px",
  p: 4,
};

const CallDashboard = () => {
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [jobsheetOpen, setJobsheetOpen] = useState(false);
  const [repairOpen, setRepairOpen] = useState(false);
  const [value, setValue] = useState({
    Servicecenter: "",
  });
  const [jobNumber, setJobNumber] = useState([]);
  const [jobStatus, setJobStatus] = useState([]);
  const [serviceCenterList, setServiceCenterList] = useState([]);
  const [engineerList, setEngineerList] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [selectedJobs, setSelectedJobs] = useState([]);
  const [jobsheetTypeList, setJobsheetTypeList] = useState([
    { title: "Repair" },
    { title: "Replacement" },
    { title: "AMC" },
  ]);
  const [organizationID, setOrganizationID] = useState("");
  const [jobID, setJobID] = useState("");
  const [loading, setLoading] = useState(false);
  const calltype = [{ title: "Option 1" }, { title: "Option 2" }];

  const calltypeDefaultProps = {
    options: calltype,
    getOptionLabel: (option) => option.title,
  };
  const [searchParams, setSearchParams] = useState({
    customerId: "",
    status: "unallocated",
    serviceCenterId: "",
    brandId: "",
    jobsheetType: "",
    jobnumber: "",
    page: 1,
    limit: 10,
  });
  const [jobParams, setJobParams] = useState({
    jobId: "",
    engineerId: "",
  });
  const handleCheckboxChange = (jobId, isChecked) => {
    setSelectedJobs((prevSelectedJobs) => {
      if (isChecked) {
        return [...prevSelectedJobs, jobId]; // Add job ID to the array
      } else {
        return prevSelectedJobs.filter((id) => id !== jobId); // Remove job ID from the array
      }
    });
    console.log("Selected Jobs:", selectedJobs);
  };

  const handlePageChange = async (newPage) => {
    console.log("newPage", newPage);
    setPage(newPage);

    const updatedParams = {
      ...searchParams,
      page: newPage.toString(),
    };

    setSearchParams(updatedParams);
    await getJobList(updatedParams); // Directly pass the updated params
  };
  const [visibleTables, setVisibleTables] = useState([]);

  const toggleTable = async (tableId) => {
    console.log("Table ID:", tableId); // Debug log
    const updatedParams = {
      ...searchParams,
      page: 1,
      pageSize: 10,
      status: tableId,
    };
    console.log("Updated Params:", updatedParams); // Debug log
    setSearchParams(updatedParams);
    try {
      setLoading(true);
      const response = await fetchJobList(updatedParams);
      if (response && response.data) {
        setTableData(response.data.data || []);
        setTotalRecords(response.data.totalRecords || 0);
      } else {
        setTableData([]);
        setTotalRecords(0);
      }
    } catch (error) {
      console.log(`Error in fetching jobs: ${error.message}`);
      setTableData([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [jobOpen, setJobOpen] = useState(false);

  const handleOpen = (jobID) => {
    setJobID(jobID);
    setIsModalOpen(true);
  };
  const handleJobView = (jobID) => {
    setJobID(jobID);
    setJobOpen(true);
  };
  const handleClose = () => {
    setIsModalOpen(false);
    setJobOpen(false);
  };

  // New handler to prevent closing on backdrop click or escape key for Job View Modal
  const handleJobViewModalClose = (event, reason) => {
    if (reason && (reason === "backdropClick" || reason === "escapeKeyDown")) {
      return; // Prevent closing
    }
    handleClose(); // Allow closing otherwise
  };

  // New handler to prevent closing on backdrop click or escape key for Repair Update Modal
  const handleRepairUpdateModalClose = (event, reason) => {
    if (reason && (reason === "backdropClick" || reason === "escapeKeyDown")) {
      return; // Prevent closing
    }
    handleClose(); // Allow closing otherwise
  };

  const handleJobsheetOpen = () => setJobsheetOpen(true);
  const handleJobsheetClose = () => setJobsheetOpen(false);

  const handleRepairOpen = () => setRepairOpen(true);
  const handleRepairClose = () => setRepairOpen(false);

  const handleChange = (event) => {
    // setAge(event.target.value);
  };
  const handleCancel = async () => {
    const updatedParams = {
      customerId: "",
      status: "",
      serviceCenterId: "",
      brandId: "",
      jobsheetType: "",
      jobnumber: "",
      page: 1,
      limit: 10,
    };
    setSearchParams(updatedParams);
    await getJobList(updatedParams);
    await getJobStatus(updatedParams);
  };
  const getJobList = async (params = searchParams) => {
    try {
      setLoading(true);

      const response = await fetchJobList(params);
      if (response) console.log(response.status);
      if (response && response.data) {
        setTableData(response.data.data || []);
        setTotalRecords(response.data.totalRecords || 0);
      }
      console.log(response.status);
    } catch (error) {
      console.log(`Error in fetching jobs: ${error.message}`);
      setTableData([]);
      // throw error;
    } finally {
      setLoading(false);
    }
  };

  const getBrandList = async () => {
    try {
      setLoading(true);
      const params = {
        status: true,
      };
      const response = await fetchBrandDropdownList(params); // API call to fetch brands
      // Filter active brands
      console.log(response.data.brandList);
      setBrandList(response.data.brandList); // Update state with active brands
    } catch (error) {
      console.log(`Error in fetching brands: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };
  const getEngineerList = async (serviceCenterId) => {
    try {
      let params = {
        forAssignEngineer: true,
        serviceCenterId,
      }
      setLoading(true);
      const response = await fetchEngineerList(params);
      if (response.status == "success") {
        console.log("response.data.engineers", response.data.engineers)
        setEngineerList(response.data.engineers); // Update state with engineer list
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error.message;
      toast.error(errorMessage);
      setEngineerList([]);
      console.log(`Error in fetching engineer list`, errorMessage);
      // throw error;
    } finally {
      setLoading(false);
    }
  };
  const getServiceCenterList = async () => {
    try {
      setLoading(true);

      const response = await fetchServieCenterList(organizationID);
      if (response.status == "success") {
        setServiceCenterList(response.data.serviceCenters); // Update state with service center list
        console.log(response.data.serviceCenters); // Update state with service center list
      }
    } catch (error) {
      console.log(`Error in fetching service center list`, error);
      const errorMessage = error?.response?.data?.message || error.message;
      toast.error(errorMessage);
      // throw error;
    }
  };

  const assignEngineerJob = async () => {
    try {
      setLoading(true);
      if (selectedJobs.length === 0) {
        toast.error("Plaese select a Job");
        return;
      }

      const response = await assignEngineer({
        jobIds: selectedJobs,
        engineerId: jobParams.engineerId,
      });

      if (response.status === "success") {
        toast.success(response.message);
        setSelectedJobs([]); // Clear selected jobs after successful assignment

        // Refresh the job status counts and job list
        await getJobStatus();
        await getJobList();

        // Clear the engineer selection
        setJobParams((prev) => ({
          ...prev,
          engineerId: "",
        }));
      }
    } catch (error) {
      console.error(`Error in assigning engineer to jobs: ${error.message}`);
      const errorMessage = error?.response?.data?.message || error.message;
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  const getJobNumber = async () => {
    try {
      setLoading(true);
      const response = await fetchJobNumber();
      if (response.status == "success") {
        console.log(response.data.jobNumber); // Update state with job number
        setJobNumber(response.data); // Update state with job number
      }
    } catch (error) {
      console.log(`Error in fetching job number`, error);
      const errorMessage = error?.response?.data?.message || error.message;
      toast.error(errorMessage);
      // throw error;
    } finally {
      setLoading(false);
    }
  };

  const getJobStatus = async (params = searchParams) => {
    try {
      setLoading(true);
      const response = await fetchJobStatus(params);

      console.log(response.data); // Update state with job number
      setJobStatus(response.data); // Update state with job number
      // }
    } catch (error) {
      console.log(`Error in fetching job status counts`, error);
      const errorMessage = error?.response?.data?.message || error.message;
      toast.error(errorMessage);
      // throw error;
    } finally {
      setLoading(false);
    }
  };
  const handleSearch = async () => {
    const updatedParams = {
      ...searchParams,
      page: 1,
    };
    setSearchParams(updatedParams);
    await getJobList(updatedParams);
  };

  // useEffect(() => {
  //   const organizationID = localStorage.getItem("organizationID");
  //   if (organizationID) {
  //     setOrganizationID(organizationID); // Parse the stored object
  //   }
  // }, []);
  useEffect(() => {
    getJobList();
    getBrandList();
    // getEngineerList();
    getServiceCenterList();
    getJobNumber();
    getJobStatus();
  }, []);
  return (
    <div className="firstbox-Reappointment" style={{ overflowX: "hidden" }}>
      {/* <div className="firstname-Reappointment">
        <div>
          <h3 className="h-dashbord">Dashboard</h3>
        </div>
      </div> */}
      <HeaderNavigation value={"Call Dashboard"} />

      <DynamicTabs />
      <Grid
        container
        flexDirection="row"
        justifyContent="flex-end"
        sx={{ pr: 3, boxSizing: "border-box" }}
      >
        <div className="textinput-two-Reappointment">
          <Autocomplete
            options={serviceCenterList} // List of service centers
            getOptionLabel={(option) => option.serviceCenter || ""} // Display `serviceCenter` property
            value={
              serviceCenterList.find(
                (item) => item._id === searchParams.serviceCenterId
              ) || null
            } // Match the value with searchParams
            onChange={(e, val) => {
              const updatedParams = {
                ...searchParams,
                serviceCenterId: val ? val._id : "", // Update serviceCenterId in searchParams with _id
              };
              setSearchParams(updatedParams);
              getJobList(updatedParams);
              getJobStatus(updatedParams);
              if (val) {
                getEngineerList(val._id);
              } else {
                setEngineerList([]); // Clear engineer list when service center is cleared
              }
            }}
            id="service-center-autocomplete"
            renderInput={(params) => (
              <TextField
                {...params}
                label="Service Center"
                variant="outlined"
              />
            )}
          />
        </div>
      </Grid>
      <Box
        className="box-Reappointment"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: "10px",
          justifyContent: "space-between",
          py: 1,
          px: 2,
          m: 0,
          width: "100%",
          boxSizing: "border-box"
        }}
      >
        {[
          { id: "unallocated", label: "Unallocated" },
          { id: "allocated", label: "Allocated" },
          { id: "reappointment", label: "Reappointment" },
          { id: "pendingForPart", label: "Pending For Part" },
          { id: "closed", label: "Closed" }
        ].map((status) => (
          <Box
            key={status.id}
            className="First-box-Reappointment"
            onClick={() => toggleTable(status.id)}
            sx={{
              cursor: "pointer",
              backgroundColor: searchParams.status === status.id ? "#33499f" : "#f5f8ff",
              color: searchParams.status === status.id ? "white" : "black",
              transition: "all 0.3s ease",
              flex: 1,
              width: "auto",
              minWidth: 0,
              maxWidth: "100%",
              padding: "10px 5px",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "10px",
              boxShadow: searchParams.status === status.id ? "0 4px 8px rgba(0,0,0,0.2)" : "none"
            }}
          >
            <Typography variant="body2" sx={{ fontSize: "14px", fontWeight: 500, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", width: "100%" }}>{status.label}</Typography>
            <Typography variant="h6" sx={{ fontSize: "18px", fontWeight: 600 }}>
              {jobStatus.find((item) => item.status === status.id)?.count || 0}
            </Typography>
          </Box>
        ))}
      </Box>

      <Box
        className="text-serchline-Reappointment"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          gap: "20px",
          justifyContent: "flex-start !important",
          width: "100%",
          boxSizing: "border-box"
        }}
      >
        <div className="textinput-two-Reappointment">
          <Autocomplete
            options={brandList} // Use the brand list from the API
            getOptionLabel={(option) => option.brandName} // Display brand names
            value={
              brandList.find((brand) => brand._id == searchParams.brandId) ||
              null
            } // Sync selected value with searchParams
            onChange={(event, value) => {
              setSearchParams((prev) => ({
                ...prev,
                brandId: value ? value._id : "", // Update brandId in searchParams
              }));
            }}
            renderInput={(params) => (
              <TextField {...params} label="Brand" variant="standard" />
            )}
          />
        </div>

        <div className="textinput-two-Reappointment">
          <Autocomplete
            options={jobsheetTypeList} // The list of options for Jobsheet Type
            getOptionLabel={(option) => option.title} // Display the `title` property
            value={
              jobsheetTypeList.find(
                (item) => item.title == searchParams.jobsheetType
              ) || null
            } // Sync with searchParams
            onChange={(e, val) => {
              setSearchParams((prev) => ({
                ...prev,
                jobsheetType: val ? val.title : "", // Update jobsheetType in searchParams
              }));
            }}
            id="disable-close-on-select"
            renderInput={(params) => (
              <TextField {...params} label="Jobsheet Type" variant="standard" />
            )}
          />
        </div>
        <div className="textinput-two-Reappointment">
          <Autocomplete
            options={jobNumber} // Use the job numbers array
            getOptionLabel={(option) => option} // Display the job number as the label
            value={searchParams.jobnumber || null} // Bind to the current `jobnumber` value
            onChange={(event, value) => {
              setSearchParams((prev) => ({
                ...prev,
                jobnumber: value || "", // Update `jobnumber` in `searchParams`
              }));
            }}
            id="job-number-dropdown"
            renderInput={(params) => (
              <TextField {...params} label="Job Number" variant="standard" />
            )}
          />
        </div>
        <CommonButton name={"Search"} handleOnClick={handleSearch} />
        <CommonButton name={"Cancel"} handleOnClick={handleCancel} />
      </Box>
      <Box
        className="text-serchline-Reappointment"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          gap: "20px",
          justifyContent: "flex-start !important",
          width: "100%",
          boxSizing: "border-box"
        }}
      >
        <div className="textinput-two-Reappointment">
          <Autocomplete
            options={engineerList} // Use the brand list from the API
            getOptionLabel={(option) => `${option.name} (allocated-${option.statusCounts.allocated || 0}) (pendingForPart-${option.statusCounts.pendingForPart || 0})`}
            value={
              engineerList.find(
                (engineer) => engineer._id == jobParams.engineerId
              ) || null
            } // Sync selected value with searchParams
            onChange={(event, value) => {
              setJobParams((prev) => ({
                ...prev,
                engineerId: value ? value._id : "", // Update brandId in searchParams
              }));
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Assign to Engineer"
                variant="standard"
              />
            )}
          />
        </div>
        <CommonButton name={"Assign"} handleOnClick={assignEngineerJob} />
        <Typography variant="body2" style={{ color: "black", fontWeight: "600" }}>
          (Note: To assign an engineer, please select a Service Center first.)
        </Typography>
      </Box>
        <TableContainer component={Paper} className="my-table" sx={{ width: '100%', overflowX: 'auto' }}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ color: "#fff" }} align="center">
                  Action
                </TableCell>
                <TableCell sx={{ color: "#fff" }} align="center">
                  Preferred Date & Time
                </TableCell>
                <TableCell sx={{ color: "#fff" }} align="center">
                  Customer Name
                </TableCell>
                <TableCell sx={{ color: "#fff" }} align="center">
                  Brand
                </TableCell>
                <TableCell sx={{ color: "#fff" }} align="center">
                  Product Name
                </TableCell>
                <TableCell sx={{ color: "#fff" }} align="center">
                  Jobsheet Number
                </TableCell>
                <TableCell sx={{ color: "#fff" }} align="center">
                  Jobsheet Date
                </TableCell>
                <TableCell sx={{ color: "#fff" }} align="center">
                  JobsheetType
                </TableCell>
                <TableCell sx={{ color: "#fff" }} align="center">
                  Engineer Name
                </TableCell>
                <TableCell sx={{ color: "#fff" }} align="center">
                  Job Status
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData?.length > 0 ? (
                tableData.map((row) => (
                  <TableRow key={row._id}>
                    <TableCell align="center">
                    <Tooltip title="Selete for assign Job" arrow >
                      <input
                        type="checkbox"
                        checked={selectedJobs.includes(row._id)} // Check if the job ID is selected
                        onChange={(e) =>
                          handleCheckboxChange(row._id, e.target.checked)
                        } // Pass the job ID and checkbox state
                      />
                       </Tooltip>
                      <Tooltip title="View Job Details" arrow >
                        <img
                          src="photos/view.png"
                          alt="View"
                          width="15"
                          onClick={() => handleJobView(row?.jobDetails._id)}
                          style={{ marginLeft: "5px", cursor: "pointer" }}
                        />
                      </Tooltip>

                      <Tooltip title="Repair Update" arrow >
                      <img
                        src="photos/close.png"
                        alt="Close"
                        width="15"
                        onClick={() => handleOpen(row?.jobDetails._id)}
                        style={{ marginLeft: "5px", cursor: "pointer" }}
                      />
                      </Tooltip>
                    </TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                      {row.jobDetails?.preferredDate
                        ? formatDate(row.jobDetails.preferredDate, "DD-MMM-YYYY")
                        : "N/A"}
                      {" & "}
                      {row.jobDetails?.preferredTime || "N/A"}
                    </TableCell>

                    <TableCell align="center">
                      {row.customerDetails?.customerName || "N/A"}
                    </TableCell>
                    <TableCell align="center">
                      {row.brandDetails?.brandName || "N/A"}
                    </TableCell>
                    <TableCell align="center">
                      {row.modelDetails?.modelName || "N/A"}
                    </TableCell>
                    <TableCell align="center">
                      {row.jobDetails?.jobNumber || "N/A"}
                    </TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                      {row.jobDetails?.createdAt
                        ? formatDate(row.jobDetails.createdAt)
                        : "N/A"}
                    </TableCell>
                    <TableCell align="center">
                      {row.jobDetails?.jobsheetType || "N/A"}
                    </TableCell>
                    <TableCell align="center">
                      {row.jobDetails?.assignedEngineerName || "N/A"}
                    </TableCell>
                    <TableCell align="center">
                      {row.jobDetails?.status || "N/A"}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    No Data Available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <div className="pagination-container">
          <Paginate
            page={page}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
          // dataSize={dataSize}
          />
        </div>

      <Modal
        open={isModalOpen}
        onClose={handleRepairUpdateModalClose} // Use the new handler for Repair Update
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableEscapeKeyDown // Explicitly disable escape key if needed (though handler covers it)
      >
        <Box sx={style}>
          {/* Add Close Button */}
          <IconButton
            aria-label="close"
            onClick={handleClose} // Call original handleClose on button click
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500], // Adjust color if needed
            }}
          >
            <CloseIcon />
          </IconButton>
          <RepairUpdate
            jobID={jobID}
            onClose={(opts) => {
              handleClose();
              if (opts?.refresh) {
                getJobList();
                getJobStatus();
              }
            }}
          />
        </Box>
      </Modal>
      <Modal
        open={jobOpen}
        onClose={handleJobViewModalClose} // Use the new handler
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableEscapeKeyDown // Explicitly disable escape key if needed (though handler covers it)
      >
        <Box sx={style}>
          {/* Add Close Button */}
          <IconButton
            aria-label="close"
            onClick={handleClose} // Call original handleClose on button click
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500], // Adjust color if needed
            }}
          >
            <CloseIcon />
          </IconButton>
          <JobsheetView jobID={jobID} onClose={handleClose} />
        </Box>
      </Modal>

      {loading && <Loader />}
      <Toaster />
    </div>
  );
};

export default CallDashboard;
